// AppMain.js
//import React, { useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
import LabIsFunLanding from './LabIsFunLanding';
import AppHead from './AppHead';

const AppMainBox = styled(Box)({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%', width: '100%',
});


export default function AppMain() {


    return (
        <AppMainBox>
            <LabIsFunLanding />
            {/* <Footer>
                    Lab is Fun, Inc. &nbsp; &nbsp;
                Seoul, Korea, Planet Earth, Virgo Supercluster of galaxies.
                &nbsp; &nbsp;
                <a onClick={onClickMail} style={{color:'rgb(63, 90, 65)'}}>email-n-tel@wont.be.exposed</a>
            </Footer> */}
            <AppHead />
        </AppMainBox>
    );
}
/*

링고붐붐(Lingo-Boom-Boom): AI를 활용한 다국어 학습 웹앱


    const onClickMail = () => {
        alert('Welcome to Lab is Fun, Inc., but we do not expose our email address.');
    };




Contents:

- 관련 사이트.
- 비전.
- 시니어 개발자의 도움이 필요한 이유.
- 연락요청을 위한 양식 - 구글 Sheets로 저장되게 하기.

비전: 프로젝트를 시작하고 완수하는 데 어려움을 겪는 스타트업 또는 소규모 팀을 돕습니다.
    멋진 아이디어로 시작하지만, 이를 실현하기 위한 자원과 경험이 부족한 스타트업 또는 소규모 팀에게 필요한 것은 적절한 기술적 리더십과 실행력을 갖춘 시니어 개발자입니다.
    그러나, 고임금의 시니어 개발자를 채용하는 것은 대부분의 경우 큰 부담이 됩니다.
    그럼에도, 프로젝트를 이끌어갈 리더십이 없다면, 프로젝트를 시작하기 위한 방향을 잡는 것 조차도 어려울 수 있습니다.
    프로젝트를 시작한 후 진행하고 마무리하는 단계까지 도움을 드립니다.
    프로젝트를 완수한 후에도 스스로 케어할 수 있도록, 프로젝트 진행 중에 문서화와 교육을 병행합니다.

아이디어를 실제 시스템으로 만들기위해서는 다음과 같은 과정이 필요합니다.
이런 작업에 도움이 필요하다고 생각되시면 저희가 도움을 드릴 수 있습니다.
만일, 이런 내용이 무슨 뜻인지 잘 모르겠다면, 절대적으로 도움이 필요한 상태이십니다.
    - 정말로 필요한 것은 무엇인가?(Idea to Requirements)
        막연한 아이디어를 '이 시스템이 반드시 해야 할 일' 목록으로 정리해야 합니다. 이 단계가 잘못되면 개발이 산으로 갑니다.
        이것은 단순한 기능 목록 작성이 아닙니다.
        사용자에게 어떤 가치를 제공할 것인지, 어떤 문제를 해결해 줄 것인지에 대한 깊은 고민이 필요하고,
        이것을 개발자들의 언어로 번역하는 작업이 필요합니다.
        이 과정에서 시스템을 만드는 것이 정말로 가능한지도 확인할 수 있습니다.
    - 시스템의 구조 설계하기(Architecture Design)
        예쁜 사이트 또는 앱 디자인을 말하는 것이 아닙니다.
        시스템의 구성 및 구조가 제공하려는 서비스의 가치창출에 적합하도록 설계하고,
        확장성, 유지보수성, 성능, 보안 등을 고려하여 기술적 토대를 마련하는 작업입니다.
        그렇다고 최고의 것들만 붙여둘 수는 없습니다. 회사의 상황, 예산, 팀의 역량 등을 고려하여 현실적인 타협안을 찾아야 합니다.
    - 적합한 기술 선택하기(Technology Stack Selection)
        시스템의 구조, 개발팀의 역량, 기술 트렌드, 예산 등을 고려하여 개발에 사용할 적합한 기술들을 선택합니다.
        사용자는 얼마나 되는지, 앞으로 얼마나 더 늘어날지, 지금은 없지만 나중에 필요할 기능은 무엇인지 등을 고려하여 선택해야 합니다.
    - 개발 계획 수립하기(Project Planning)
        현실적인 일정과 마일스톤을 설정하고, 개발팀의 역할과 책임을 명확히 정의합니다.
        필요하다면, 새로운 개발자를 상시 또는 임시로 채용하는 것도 고려해야 합니다.
    - 정말로 만들기(Development)
        계획에 따라 실제로 시스템을 개발하는 단계입니다.
        개발 과정에서 발생하는 문제들을 해결하고, 계획에 맞게 진행되도록 관리하는 것이 중요합니다.
    - 테스트 및 설치하기(Testing and Deployment)
        개발된 시스템이 요구사항을 충족하는지, 버그가 없는지 확인하고, 필요하다면 수정합니다.
        실제 운영할 서버를 준비하고 시스템을 설치하는 작업도 포함됩니다.
        최종적으로 사용자가 시스템을 사용할 수 있다고 확신하면 서비스를 시작합니다.
    - 문서화하기(Documentation)
        시스템의 구조, 사용법, 유지보수 방법 등을 문서화하여, 이후에 시스템을 관리하고 확장하는 데 도움이 되도록 합니다.
        운영팀이 별도로 있다면, 그 팀이 시스템을 이해하고 관리할 수 있도록 충분한 정보를 제공합니다.
    - 미세 조정 및 유지보수하기(Fine-tuning and Maintenance)
        시스템이 안정적으로 운영되도록 모니터링하고, 필요하다면 성능을 개선하거나 버그를 수정합니다.
        사용자의 피드백을 반영하여 시스템을 개선하는 작업도 포함됩니다.

    이러한 작업들은 각 업체의 상황에 따라 긴 버전과 짧은 버전이 있을 수 있습니다.
    대기업 또는 중견기업의 프로젝트와 비교할 때,
    소규모 팀과 스타트업이 가지는 시간적, 재정적 제약 등을 고려하면,
    이러한 작업들을 모두 원칙대로 수행하는 것이 어려울 수 있습니다.
    결국, 현실적인 타협안을 찾는 것이 필요하며, 그런 제약을 다루어 본 시니어 개발자의 경험이 큰 도움이 될 수 있습니다.

도움이 필요하다고 생각되시거나, 내가 도움이 필요한지 아닌지도 잘 모르겠다면, 마음 편히 연락처를 남겨주시기 바랍니다.

*/
